import { styled } from '@mui/system';
import { Typography } from '@components/Typography';
import { MEDIA_STATUS } from '@constants/profiles-media';

export const Container = styled('div')({
    '@media (max-width: 1024px)': {
        padding: 16,
    },
});

export const Content = styled('div')({
    height: 'calc(var(--100vh) - 96px - var(--page-title-height))',
    overflowY: 'auto',
    '@media (max-width: 1024px)': {
        height: 'calc(var(--100vh) - 188px)',
    },
});

export const FiltersWrapper = styled('div')({
    marginBottom: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    '@media print': {
        display: 'none',
    },
});

export const Badge = styled(Typography, {
    shouldForwardProp: prop => prop !== 'type',
})(({ type }) => ({
    padding: '2px 6px',
    backgroundColor: type === MEDIA_STATUS.NEW ? 'rgba(11, 141, 0, 0.1)' : 'rgba(176, 0, 32, 0.1)',
    color: type === MEDIA_STATUS.NEW ? 'var(--success-main)' : 'var(--error-main)',
}));
